import { render } from "./AllergenImage.vue?vue&type=template&id=24246cb9&scoped=true"
import script from "./AllergenImage.vue?vue&type=script&lang=js"
export * from "./AllergenImage.vue?vue&type=script&lang=js"

import "./AllergenImage.vue?vue&type=style&index=0&id=24246cb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24246cb9"]])

export default __exports__